import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import type { LandingPageCampaign } from '@feathr/blackbox';
import { CardV2 as Card } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import { AddGoals } from '../../CampaignEditPage/StepGoals';
import LandingPageCampaignInfo from './LandingPageCampaignInfo';
import LandingPageCampaignPage from './LandingPageCampaignPage';

function SettingsLandingPageCampaignPage(): JSX.Element {
  const { t } = useTranslation();

  const { campaignId } = useParams<{ eventId: string; campaignId: string }>();
  const { Campaigns, Goals } = useStore();
  const campaign = Campaigns.get(campaignId) as LandingPageCampaign;

  const goals = Goals.list({
    filters: {
      _parent: campaignId,
      is_archived__ne: true,
    },
  });

  return (
    <LandingPageCampaignPage title={'Settings'}>
      <Card>
        <Card.Header title={t('Campaign Info')} />
        <Card.Content>
          <LandingPageCampaignInfo campaign={campaign} />
        </Card.Content>
      </Card>
      <Card>
        <Card.Header description={t('Configure the goals for this campaign.')} title={t('Goals')} />
        <Card.Content addVerticalGap={true}>
          <AddGoals goalKind={'campaign'} goals={goals.models} parent={campaign} />
        </Card.Content>
      </Card>
    </LandingPageCampaignPage>
  );
}

export default observer(SettingsLandingPageCampaignPage);
